"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SRStyle = exports.SRCenter = exports.ScaleRotateMode = exports.icon = void 0;
const Constants = __importStar(require("@mapbox/mapbox-gl-draw/src/constants"));
const double_click_zoom_1 = __importDefault(require("@mapbox/mapbox-gl-draw/src/lib/double_click_zoom"));
const create_supplementary_points_1 = __importDefault(require("@mapbox/mapbox-gl-draw/src/lib/create_supplementary_points"));
const CommonSelectors = __importStar(require("@mapbox/mapbox-gl-draw/src/lib/common_selectors"));
const move_features_1 = __importDefault(require("@mapbox/mapbox-gl-draw/src/lib/move_features"));
const helpers_1 = require("@turf/helpers");
const bearing_1 = __importDefault(require("@turf/bearing"));
const center_1 = __importDefault(require("@turf/center"));
const midpoint_1 = __importDefault(require("@turf/midpoint"));
const distance_1 = __importDefault(require("@turf/distance"));
const destination_1 = __importDefault(require("@turf/destination"));
const transform_rotate_1 = __importDefault(require("@turf/transform-rotate"));
const transform_scale_1 = __importDefault(require("@turf/transform-scale"));
exports.icon = `
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="18" height="18" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.86 9.05C12.51 9.21 13 9.8 13 10.5C13 11.33 12.33 12 11.5 12C10.8 12 10.21 11.51 10.05 10.86H3.95C3.79 11.51 3.2 12 2.5 12C1.67 12 1 11.33 1 10.5C1 9.8 1.49 9.21 2.14 9.05V2.95C1.49 2.79 1 2.2 1 1.5C1 0.67 1.67 0 2.5 0C3.2 0 3.79 0.49 3.95 1.14H10.05C10.21 0.49 10.8 0 11.5 0C12.33 0 13 0.67 13 1.5C13 2.2 12.51 2.79 11.86 2.95V9.05ZM3.95 10.14H10.05C10.18 9.6 10.6 9.18 11.14 9.05V2.95C10.6 2.82 10.18 2.4 10.05 1.86H3.95C3.82 2.4 3.4 2.82 2.86 2.95V9.05C3.4 9.18 3.82 9.6 3.95 10.14ZM17.9001 12.99L17.9101 13L17.9201 12.99H17.9001ZM17.9001 12.99L16.5001 11.59L15.0901 13H16.1301V14.25C16.1301 15.28 15.2901 16.12 14.2601 16.12H13.0101V15.08L11.6001 16.49L13.0101 17.9V16.86H14.2601C15.7101 16.86 16.8801 15.68 16.8801 14.24V12.99H17.9001ZM7.29994 3H6.68994V5H7.29994V3ZM6.68994 7H7.29994V9H6.68994V7ZM6 5.68994H4V6.29994H6V5.68994ZM8 5.68994H10V6.29994H8V5.68994Z" fill="#1460CC"/>
</svg>
`;
const rotate = `
<svg width="24px" height="24px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="rotateIconTitle" 
  stroke="#f2f2f2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" 
  color="#f2f2f2"> 
  <title id="rotateIconTitle">Rotate</title> <path d="M22 12l-3 3-3-3"/> 
  <path d="M2 12l3-3 3 3"/> 
  <path d="M19.016 14v-1.95A7.05 7.05 0 0 0 8 6.22"/> 
  <path d="M16.016 17.845A7.05 7.05 0 0 1 5 12.015V10"/> 
  <path stroke-linecap="round" d="M5 10V9"/>
  <path stroke-linecap="round" d="M19 15v-1"/> 
</svg>
`;
const scale = `
<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.75781 5.04074L9.17203 6.45495L11.0005 4.62649V9.99996H13.0005V4.62658L14.8289 6.45495L16.2431 5.04074L12.0005 0.798096L7.75781 5.04074Z" fill="#f2f2f2"/>
  <path d="M16.2431 18.9592L14.8289 17.545L13.0005 19.3734V14H11.0005V19.3735L9.17203 17.545L7.75781 18.9592L12.0004 23.2019L16.2431 18.9592Z" fill="#f2f2f2"/>
</svg>
`;
// require('./img/scale.png');
exports.ScaleRotateMode = {}; //scale rotate mode
exports.SRCenter = {
    Center: 0,
    Opposite: 1, // rotate or scale around opposite side of polygon
};
exports.SRStyle = [
    {
        id: "gl-draw-scale-vertex-point-active",
        type: "circle",
        filter: [
            "all",
            ["==", "$type", "Point"],
            ["==", "meta", "vertex"],
            ["==", "active", "true"],
            ["has", "heading"],
        ],
        paint: {
            "circle-radius": 4,
            "circle-color": "#f2f2f2",
        },
    },
    {
        id: "gl-draw-scale-vertex-point-icon",
        type: "symbol",
        filter: [
            "all",
            ["==", "meta", "vertex"],
            ["==", "$type", "Point"],
            ["!=", "mode", "static"],
            ["has", "heading"],
        ],
        layout: {
            "icon-image": "scale",
            "icon-allow-overlap": true,
            "icon-ignore-placement": true,
            "icon-rotation-alignment": "map",
            "icon-rotate": ["get", "heading"],
        },
        paint: {
            "icon-opacity": 1.0,
            "icon-opacity-transition": {
                delay: 0,
                duration: 0,
            },
        },
    },
    {
        id: "gl-draw-scale-rotate-point-icon",
        type: "symbol",
        filter: [
            "all",
            // ['==', 'meta', 'midpoint'],
            ["==", "icon", "rotate"],
            ["==", "$type", "Point"],
            ["!=", "mode", "static"],
        ],
        layout: {
            "icon-image": "rotate",
            "icon-allow-overlap": true,
            "icon-ignore-placement": true,
            "icon-rotation-alignment": "map",
            "icon-rotate": ["get", "heading"],
        },
        paint: {
            "icon-opacity": 1.0,
            "icon-opacity-transition": {
                delay: 0,
                duration: 0,
            },
        },
    },
];
function parseSRCenter(value, defaultSRCenter = exports.SRCenter.Center) {
    if (value === undefined || value === null)
        return defaultSRCenter;
    if (value === exports.SRCenter.Center || value === exports.SRCenter.Opposite)
        return value;
    if (value === "center")
        return exports.SRCenter.Center;
    if (value === "opposite")
        return exports.SRCenter.Opposite;
    throw Error("Invalid SRCenter: " + value);
}
const DefaultOpts = {
    canScale: true,
    canRotate: true,
    canTrash: false,
    rotatePivot: exports.SRCenter.Center,
    scaleCenter: exports.SRCenter.Center,
    singleRotationPoint: true,
    singleScalePoint: true,
    rotationPointRadius: 1.2,
    canSelectFeatures: true,
};
exports.ScaleRotateMode.onSetup = function (opts) {
    var _a;
    opts = opts
        ? Object.assign(Object.assign({}, DefaultOpts), opts) : DefaultOpts;
    const featureId = (_a = this.getSelected()[0]) === null || _a === void 0 ? void 0 : _a.id;
    if (!featureId) {
        throw new Error("You must provide a valid featureId to enter ScaleRotateMode");
    }
    const feature = this.getFeature(featureId);
    if (!feature) {
        throw new Error(`Feature with featureId ${featureId} ot found and is required to enter ScaleRotateMode`);
    }
    if (feature.type === Constants.geojsonTypes.POINT ||
        feature.type === Constants.geojsonTypes.MULTI_POINT) {
        throw new TypeError("ScaleRotateMode can not handle points");
    }
    //   if (
    //     feature.coordinates === undefined ||
    //     feature.coordinates.length != 1 ||
    //     feature.coordinates[0].length <= 2
    //   ) {
    //     throw new TypeError('ScaleRotateMode can only handle polygons');
    //   }
    const state = {
        featureId,
        feature,
        canTrash: opts.canTrash !== undefined ? opts.canTrash : true,
        canScale: opts.canScale !== undefined ? opts.canScale : true,
        canRotate: opts.canRotate !== undefined ? opts.canRotate : true,
        singleRotationPoint: opts.singleRotationPoint !== undefined ? opts.singleRotationPoint : false,
        rotationPointRadius: opts.rotationPointRadius !== undefined ? opts.rotationPointRadius : 1.0,
        singleScalePoint: opts.singleScalePoint !== undefined ? opts.singleScalePoint : false,
        rotatePivot: parseSRCenter(opts.rotatePivot, exports.SRCenter.Center),
        scaleCenter: parseSRCenter(opts.scaleCenter, exports.SRCenter.Center),
        canSelectFeatures: opts.canSelectFeatures !== undefined ? opts.canSelectFeatures : true,
        // selectedFeatureMode: opts.selectedFeatureMode !== undefined ? opts.selectedFeatureMode : 'simple_select',
        dragMoveLocation: opts.startPos || null,
        dragMoving: false,
        canDragMove: false,
        selectedCoordPaths: opts.coordPath ? [opts.coordPath] : [],
    };
    if (!(state.canRotate || state.canScale)) {
        console.warn("Non of canScale or canRotate is true");
    }
    this.setSelectedCoordinates(this.pathsToCoordinates(featureId, state.selectedCoordPaths));
    this.setSelected(featureId);
    double_click_zoom_1.default.disable(this);
    this.setActionableState({
        combineFeatures: false,
        uncombineFeatures: false,
        trash: state.canTrash,
    });
    const img = new Image(32, 32);
    img.onload = () => {
        if (!this.map.hasImage("scale")) {
            this.map.addImage("scale", img);
        }
    };
    img.src = `data:image/svg+xml;base64,${btoa(scale)}`;
    const rotateImg = new Image(32, 32);
    rotateImg.onload = () => {
        if (!this.map.hasImage("rotate")) {
            this.map.addImage("rotate", rotateImg);
        }
    };
    rotateImg.src = `data:image/svg+xml;base64,${btoa(rotate)}`;
    return state;
};
exports.ScaleRotateMode.toDisplayFeatures = function (state, geojson, push) {
    if (state.featureId === geojson.properties.id) {
        geojson.properties.active = Constants.activeStates.ACTIVE;
        push(geojson);
        const suppPoints = (0, create_supplementary_points_1.default)(geojson, {
            map: this.map,
            midpoints: false,
            selectedPaths: state.selectedCoordPaths,
        });
        // const bounds = this.map.getBounds();
        // const brPoint = nearestPoint([bounds.getEast(), bounds.getSouth()], {
        //   type: "FeatureCollection",
        //   features: suppPoints
        // });
        if (state.canScale) {
            this.computeBisectrix(suppPoints);
            if (!state.singleScalePoint) {
                suppPoints.forEach(push);
            }
            else {
                // brPoint.properties.heading = 315
                push(suppPoints[0]);
            }
        }
        if (state.canRotate) {
            const rotPoints = this.createRotationPoints(state, geojson, suppPoints);
            rotPoints.forEach(push);
        }
    }
    else {
        geojson.properties.active = Constants.activeStates.INACTIVE;
        push(geojson);
    }
    // this.fireActionable(state);
    this.setActionableState({
        combineFeatures: false,
        uncombineFeatures: false,
        trash: state.canTrash,
    });
    // this.fireUpdate(state);
};
exports.ScaleRotateMode.onStop = function () {
    double_click_zoom_1.default.enable(this);
    this.clearSelectedCoordinates();
};
// TODO why I need this?
exports.ScaleRotateMode.pathsToCoordinates = function (featureId, paths) {
    return paths.map((coord_path) => {
        return { feature_id: featureId, coord_path };
    });
};
exports.ScaleRotateMode.computeBisectrix = function (points) {
    for (let i1 = 0; i1 < points.length; i1++) {
        const i0 = (i1 - 1 + points.length) % points.length;
        const i2 = (i1 + 1) % points.length;
        // const l1 = lineString([
        //   points[i0].geometry.coordinates,
        //   points[i1].geometry.coordinates,
        // ]);
        // const l2 = lineString([
        //   points[i1].geometry.coordinates,
        //   points[i2].geometry.coordinates,
        // ]);
        const a1 = (0, bearing_1.default)(points[i0].geometry.coordinates, points[i1].geometry.coordinates);
        const a2 = (0, bearing_1.default)(points[i2].geometry.coordinates, points[i1].geometry.coordinates);
        let a = (a1 + a2) / 2.0;
        if (a < 0.0)
            a += 360;
        if (a > 360)
            a -= 360;
        points[i1].properties.heading = a;
    }
};
exports.ScaleRotateMode._createRotationPoint = function (rotationWidgets, featureId, v1, v2, rotCenter, radiusScale) {
    const cR0 = (0, midpoint_1.default)(v1, v2).geometry.coordinates;
    const heading = (0, bearing_1.default)(rotCenter, cR0);
    const distance0 = (0, distance_1.default)(rotCenter, cR0);
    const distance1 = radiusScale * distance0; // TODO depends on map scale
    const cR1 = (0, destination_1.default)(rotCenter, distance1, heading, {}).geometry
        .coordinates;
    rotationWidgets.push({
        type: Constants.geojsonTypes.FEATURE,
        properties: {
            meta: Constants.meta.MIDPOINT,
            icon: "rotate",
            parent: featureId,
            lng: cR1[0],
            lat: cR1[1],
            coord_path: v1.properties.coord_path,
            heading: heading,
        },
        geometry: {
            type: Constants.geojsonTypes.POINT,
            coordinates: cR1,
        },
    });
};
exports.ScaleRotateMode.createRotationPoints = function (state, geojson, suppPoints) {
    const { type } = geojson.geometry;
    const featureId = geojson.properties && geojson.properties.id;
    const rotationWidgets = [];
    if (type === Constants.geojsonTypes.POINT ||
        type === Constants.geojsonTypes.MULTI_POINT) {
        return;
    }
    const corners = suppPoints.slice(0);
    corners[corners.length] = corners[0];
    let v1 = null;
    const rotCenter = this.computeRotationCenter(state, geojson);
    if (state.singleRotationPoint) {
        this._createRotationPoint(rotationWidgets, featureId, corners[0], corners[1], rotCenter, state.rotationPointRadius);
    }
    else {
        corners.forEach((v2) => {
            if (v1 !== null) {
                this._createRotationPoint(rotationWidgets, featureId, v1, v2, rotCenter, state.rotationPointRadius);
            }
            v1 = v2;
        });
    }
    return rotationWidgets;
};
exports.ScaleRotateMode.startDragging = function (state, e) {
    this.map.dragPan.disable();
    state.canDragMove = true;
    state.dragMoveLocation = e.lngLat;
};
exports.ScaleRotateMode.stopDragging = function (state) {
    this.map.dragPan.enable();
    state.dragMoving = false;
    state.canDragMove = false;
    state.dragMoveLocation = null;
};
const isRotatePoint = CommonSelectors.isOfMetaType(Constants.meta.MIDPOINT);
const isVertex = CommonSelectors.isOfMetaType(Constants.meta.VERTEX);
exports.ScaleRotateMode.onTouchStart = exports.ScaleRotateMode.onMouseDown = function (state, e) {
    if (isVertex(e))
        return this.onVertex(state, e);
    if (isRotatePoint(e))
        return this.onRotatePoint(state, e);
    if (CommonSelectors.isActiveFeature(e))
        return this.onFeature(state, e);
    // if (isMidpoint(e)) return this.onMidpoint(state, e);
};
const TxMode = {
    Scale: 1,
    Rotate: 2,
};
exports.ScaleRotateMode.onVertex = function (state, e) {
    // convert internal MapboxDraw feature to valid GeoJSON:
    this.computeAxes(state, state.feature.toGeoJSON());
    this.startDragging(state, e);
    const about = e.featureTarget.properties;
    state.selectedCoordPaths = [about.coord_path];
    state.txMode = TxMode.Scale;
};
exports.ScaleRotateMode.onRotatePoint = function (state, e) {
    // convert internal MapboxDraw feature to valid GeoJSON:
    this.computeAxes(state, state.feature.toGeoJSON());
    this.startDragging(state, e);
    const about = e.featureTarget.properties;
    state.selectedCoordPaths = [about.coord_path];
    state.txMode = TxMode.Rotate;
};
exports.ScaleRotateMode.onFeature = function (state, e) {
    state.selectedCoordPaths = [];
    this.startDragging(state, e);
};
exports.ScaleRotateMode.coordinateIndex = function (coordPaths) {
    if (coordPaths.length >= 1) {
        const parts = coordPaths[0].split(".");
        return parseInt(parts[parts.length - 1]);
    }
    else {
        return 0;
    }
};
exports.ScaleRotateMode.computeRotationCenter = function (state, polygon) {
    const center0 = (0, center_1.default)(polygon);
    return center0;
};
exports.ScaleRotateMode.computeAxes = function (state, polygon) {
    // TODO check min 3 points
    const center0 = this.computeRotationCenter(state, polygon);
    let corners;
    if (polygon.geometry.type === Constants.geojsonTypes.POLYGON)
        corners = polygon.geometry.coordinates[0].slice(0);
    else if (polygon.geometry.type === Constants.geojsonTypes.MULTI_POLYGON) {
        const temp = [];
        polygon.geometry.coordinates.forEach((c) => {
            c.forEach((c2) => {
                c2.forEach((c3) => {
                    temp.push(c3);
                });
            });
        });
        corners = temp;
    }
    else if (polygon.geometry.type === Constants.geojsonTypes.LINE_STRING)
        corners = polygon.geometry.coordinates;
    else if (polygon.geometry.type === Constants.geojsonTypes.MULTI_LINE_STRING) {
        const temp = [];
        polygon.geometry.coordinates.forEach((c) => {
            c.forEach((c2) => {
                temp.push(c2);
            });
        });
        corners = temp;
    }
    const n = corners.length - 1;
    const iHalf = Math.floor(n / 2);
    const rotateCenters = [];
    const headings = [];
    for (let i1 = 0; i1 < n; i1++) {
        let i0 = i1 - 1;
        if (i0 < 0)
            i0 += n;
        const c0 = corners[i0];
        const c1 = corners[i1];
        const rotPoint = (0, midpoint_1.default)((0, helpers_1.point)(c0), (0, helpers_1.point)(c1));
        let rotCenter = center0;
        if (exports.SRCenter.Opposite === state.rotatePivot) {
            const i3 = (i1 + iHalf) % n; // opposite corner
            let i2 = i3 - 1;
            if (i2 < 0)
                i2 += n;
            const c2 = corners[i2];
            const c3 = corners[i3];
            rotCenter = (0, midpoint_1.default)((0, helpers_1.point)(c2), (0, helpers_1.point)(c3));
        }
        rotateCenters[i1] = rotCenter.geometry.coordinates;
        headings[i1] = (0, bearing_1.default)(rotCenter, rotPoint);
    }
    state.rotation = {
        feature0: polygon,
        centers: rotateCenters,
        headings: headings, // rotation start heading for each point
    };
    // compute current distances from centers for scaling
    const scaleCenters = [];
    const distances = [];
    for (let i = 0; i < n; i++) {
        const c1 = corners[i];
        let c0 = center0.geometry.coordinates;
        if (exports.SRCenter.Opposite === state.scaleCenter) {
            const i2 = (i + iHalf) % n; // opposite corner
            c0 = corners[i2];
        }
        scaleCenters[i] = c0;
        distances[i] = (0, distance_1.default)((0, helpers_1.point)(c0), (0, helpers_1.point)(c1), { units: "meters" });
    }
    state.scaling = {
        feature0: polygon,
        centers: scaleCenters,
        distances: distances,
    };
};
exports.ScaleRotateMode.onDrag = function (state, e) {
    if (state.canDragMove !== true)
        return;
    state.dragMoving = true;
    e.originalEvent.stopPropagation();
    const delta = {
        lng: e.lngLat.lng - state.dragMoveLocation.lng,
        lat: e.lngLat.lat - state.dragMoveLocation.lat,
    };
    if (state.selectedCoordPaths.length > 0 && state.txMode) {
        switch (state.txMode) {
            case TxMode.Rotate:
                this.dragRotatePoint(state, e, delta);
                break;
            case TxMode.Scale:
                this.dragScalePoint(state, e, delta);
                break;
        }
    }
    else {
        this.dragFeature(state, e, delta);
    }
    state.dragMoveLocation = e.lngLat;
};
exports.ScaleRotateMode.dragRotatePoint = function (state, e) {
    if (state.rotation === undefined || state.rotation === null) {
        throw new Error("state.rotation required");
    }
    const m1 = (0, helpers_1.point)([e.lngLat.lng, e.lngLat.lat]);
    const n = state.rotation.centers.length;
    const cIdx = (this.coordinateIndex(state.selectedCoordPaths) + 1) % n;
    // TODO validate cIdx
    const cCenter = state.rotation.centers[cIdx];
    const center = (0, helpers_1.point)(cCenter);
    const heading1 = (0, bearing_1.default)(center, m1);
    const heading0 = state.rotation.headings[cIdx];
    let rotateAngle = heading1 - heading0; // in degrees
    if (CommonSelectors.isShiftDown(e)) {
        rotateAngle = 5.0 * Math.round(rotateAngle / 5.0);
    }
    const rotatedFeature = (0, transform_rotate_1.default)(state.rotation.feature0, rotateAngle, {
        pivot: center,
        mutate: false,
    });
    state.feature.incomingCoords(rotatedFeature.geometry.coordinates);
    // TODO add option for this:
    this.fireUpdate(state);
};
exports.ScaleRotateMode.dragScalePoint = function (state, e) {
    if (state.scaling === undefined || state.scaling === null) {
        throw new Error("state.scaling required");
    }
    const cIdx = this.coordinateIndex(state.selectedCoordPaths);
    // TODO validate cIdx
    const cCenter = state.scaling.centers[cIdx];
    const center = (0, helpers_1.point)(cCenter);
    const m1 = (0, helpers_1.point)([e.lngLat.lng, e.lngLat.lat]);
    const dist = (0, distance_1.default)(center, m1, { units: "meters" });
    let scale = dist / state.scaling.distances[cIdx];
    if (CommonSelectors.isShiftDown(e)) {
        // TODO discrete scaling
        scale = 0.05 * Math.round(scale / 0.05);
    }
    const scaledFeature = (0, transform_scale_1.default)(state.scaling.feature0, scale, {
        origin: cCenter,
        mutate: false,
    });
    state.feature.incomingCoords(scaledFeature.geometry.coordinates);
    // TODO add option for this:
    this.fireUpdate(state);
};
exports.ScaleRotateMode.dragFeature = function (state, e, delta) {
    (0, move_features_1.default)(this.getSelected(), delta);
    state.dragMoveLocation = e.lngLat;
    // TODO add option for this:
    this.fireUpdate(state);
};
exports.ScaleRotateMode.fireUpdate = function (state) {
    if (!state.dragMoving) {
        this.map.fire(Constants.events.UPDATE, {
            action: Constants.updateActions.CHANGE_COORDINATES,
            features: this.getSelected().map((f) => f.toGeoJSON()),
        });
    }
};
exports.ScaleRotateMode.onMouseOut = function (state) {
    // As soon as you mouse leaves the canvas, update the feature
    if (state.dragMoving) {
        this.stopDragging(state);
        this.fireUpdate(state);
    }
};
exports.ScaleRotateMode.onTouchEnd = exports.ScaleRotateMode.onMouseUp = function (state) {
    this.stopDragging(state);
    this.fireUpdate(state);
};
exports.ScaleRotateMode.clickActiveFeature = function (state) {
    state.selectedCoordPaths = [];
    this.clearSelectedCoordinates();
    state.feature.changed();
};
exports.ScaleRotateMode.onClick = function (state, e) {
    if (CommonSelectors.noTarget(e))
        return this.clickNoTarget(state, e);
    if (CommonSelectors.isActiveFeature(e))
        return this.clickActiveFeature(state, e);
    if (CommonSelectors.isInactiveFeature(e))
        return this.clickInactive(state, e);
    this.stopDragging(state);
};
exports.ScaleRotateMode.clickNoTarget = function (state) {
    if (state.canSelectFeatures)
        this.changeMode(Constants.modes.SIMPLE_SELECT);
};
exports.ScaleRotateMode.clickInactive = function (state, e) {
    if (state.canSelectFeatures)
        this.changeMode(Constants.modes.SIMPLE_SELECT, {
            featureIds: [e.featureTarget.properties.id],
        });
};
exports.ScaleRotateMode.onTrash = function () {
    this.deleteFeature(this.getSelectedIds());
    // this.fireActionable();
};
